import { StringConstantsMixin } from 'react_components/mixins/shared/string_constants_mixin';
import { ServerCommunicationUtil } from './server_communication_util';

const facebookHandler = (
  response: { accessToken: any; userID: any; expiresIn: any },
  locale: string,
  successCallback: Function = () => {},
  errorCallback = () => {},
  completeCallback = () => {},
  referralLink?: string
) => {
  if (!response.accessToken) {
    return;
  }

  const fbData = {
    facebook_id: response.userID,
    facebook_token: response.accessToken,
    facebook_expires: response.expiresIn,
    create_session: true,
    ...(referralLink && { referral_code: referralLink })
  };
  const headers = locale ? { 'X-Language-Locale': locale } : {};

  ServerCommunicationUtil.postApiEndpoint('/api/alltrails/facebook/login', fbData, successCallback, errorCallback, completeCallback, headers);
};

const appleHandler = (referralLink?: string) => {
  let redirectURI = `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}${
    StringConstantsMixin.constants.APPLE_SIWA.REDIRECT_PATH
  }`;

  if (referralLink) {
    const params = new URLSearchParams();
    params.set('referral_code', referralLink);
    redirectURI += `?${params.toString()}`;
  }

  const authUrl = `${StringConstantsMixin.constants.APPLE_SIWA.AUTHORIZE_URL +
    StringConstantsMixin.constants.APPLE_SIWA.AUTHORIZE_PARAMS}&client_id=${
    StringConstantsMixin.constants.APPLE_SIWA.CLIENT_ID
  }&redirect_uri=${encodeURIComponent(redirectURI)}&scope=${encodeURIComponent(StringConstantsMixin.constants.APPLE_SIWA.SCOPES)}`;

  window.location.href = authUrl;
};

const googleHandler = (
  googleUser: { getAuthResponse: () => { (): any; new (): any; id_token: any } },
  locale: string,
  successCallback: Function = () => {},
  errorCallback = () => {},
  completeCallback = () => {},
  referralLink?: string
) => {
  const token = googleUser.getAuthResponse().id_token;
  const data = { google_token: token, create_session: true, ...(referralLink && { referral_code: referralLink }) };
  const headers = locale ? { 'X-Language-Locale': locale } : {};
  ServerCommunicationUtil.postApiEndpoint('/api/alltrails/google/login', data, successCallback, errorCallback, completeCallback, headers);
};

export { facebookHandler, appleHandler, googleHandler };
